import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'

export default {
  name      : 'AccountPersonalInfo',
  components: {},
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {},
  enums     : {},
  dataStore : {},
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase
  }
}
